// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"52e6c4a4","683":"d4011070"}[chunkId] + ".chunk.css";
};